import { useEffect, useState } from 'react';
import HeroSlider from '../components/HeroSlider';
import BlogCard from '../components/BlogCard';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import VideoSection from '../components/VideoSection';
import useScrollReveal from '../hooks/useScrollReveal';
import API from '../utils/api';

const PageTemplate = ({ page, pageName, tagline, description, about, icon, accentColor }) => {
  const [blogs, setBlogs] = useState([]);
  const [showAll, setShowAll] = useState(false);
  useScrollReveal();

  useEffect(() => {
    API.get(`/blogs/page/${page}`).then(r => setBlogs(r.data)).catch(() => {});
  }, [page]);

  const displayedBlogs = showAll ? blogs : blogs.slice(0, 6);

  return (
    <div>
      <HeroSlider page={page} pageName={pageName} />

      {/* About Section */}
      <section className="section">
        <div className="about-grid">
          <div className="about-image-wrap reveal">
            <div style={{ 
              width: '100%', aspectRatio: '4/5',
              background: `linear-gradient(135deg, var(--forest) 0%, ${accentColor || 'var(--gold)'} 100%)`,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              flexDirection: 'column', gap: 20, color: 'white'
            }}>
              <div style={{ fontSize: '5rem', lineHeight: 1 }}>{icon}</div>
              <p style={{ 
                fontFamily: 'Cormorant Garamond, serif', 
                fontSize: '1.8rem', 
                fontStyle: 'italic',
                textAlign: 'center', 
                padding: '0 32px',
                opacity: 0.9
              }}>
                {tagline}
              </p>
            </div>
          </div>
          <div className="reveal reveal-delay-2">
            <div className="section-label"><span>{pageName}</span></div>
            <h2 className="section-title">{about.title}</h2>
            <div className="divider" />
            <p className="section-desc">{about.paragraph1}</p>
            {about.paragraph2 && (
              <p className="section-desc" style={{ marginTop: 16 }}>{about.paragraph2}</p>
            )}
            {about.points && (
              <ul style={{ marginTop: 28, listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 12 }}>
                {about.points.map((point, i) => (
                  <li key={i} style={{ 
                    display: 'flex', alignItems: 'flex-start', gap: 12,
                    padding: '12px 16px', background: 'var(--cream-dark)',
                    borderLeft: '3px solid var(--gold)', fontSize: '0.93rem', color: 'var(--warm-gray)'
                  }}>
                    <span style={{ color: 'var(--gold)', flexShrink: 0, marginTop: 2 }}>✦</span>
                    {point}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </section>

      {/* Blogs Section */}
      <section className="section" style={{ background: 'var(--cream-dark)', paddingTop: 80 }}>
        <div className="reveal" style={{ marginBottom: 12 }}>
          <div className="section-label"><span>{pageName} Articles</span></div>
          <h2 className="section-title">Insights & Perspectives</h2>
        </div>

        <div className="blogs-grid">
          {displayedBlogs.length > 0
            ? displayedBlogs.map((blog, i) => <BlogCard key={blog._id} blog={blog} delay={i * 80} />)
            : [0,1,2].map(i => (
                <div key={i} className="blog-card reveal" style={{ transitionDelay: `${i * 100}ms` }}>
                  <div style={{ width: '100%', aspectRatio: '16/10', background: 'var(--cream)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--light-border)', fontSize: '2rem' }}>✦</div>
                  <div className="blog-card-body">
                    <span className="blog-card-tag">{pageName}</span>
                    <h3 className="blog-card-title">Articles coming soon</h3>
                    <p className="blog-card-excerpt">Admin will publish articles for this section. Stay tuned for inspiring content about {pageName.toLowerCase()}.</p>
                  </div>
                </div>
              ))
          }
        </div>

        {!showAll && blogs.length > 6 && (
          <div className="view-all-wrap">
            <button className="btn-outline" onClick={() => setShowAll(true)}>
              View All Articles ({blogs.length}) →
            </button>
          </div>
        )}
        {showAll && blogs.length > 6 && (
          <div className="view-all-wrap">
            <button className="btn-outline" onClick={() => setShowAll(false)}>
              Show Less ↑
            </button>
          </div>
        )}
      </section>

      {/* Videos Section */}
      <VideoSection page={page} />

      <ContactSection />
      <Footer />
    </div>
  );
};

export default PageTemplate;
